<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs()" />
<div class="border-b border-solid border-slate-300"></div>

<div class="mx-auto flex max-w-5xl flex-col gap-4 p-4">
  <h1 class="mat-headline-4 !mb-0">Referral Settings</h1>

  <pr-content-container>
    <h2 class="text-xl font-bold">Email Template Defaults</h2>

    <pr-information-box>
      Configure the default email templates and subjects for referral emails
      sent from each practice. Changes are saved automatically.
    </pr-information-box>

    @if (brand(); as currentBrand) {
      <div class="mt-4 flex items-start gap-4">
        <pr-practice-selector
          class="flex-1"
          subscriptSizing="dynamic"
          [brands]="[currentBrand]"
          (practiceSelected)="selectedPractice.set($event)"
        />

        @if (organisation.hasMultiplePractices$ | async) {
          <button
            mat-stroked-button
            matTooltip="Copy the current practice's settings to all other practices"
            (click)="applyToAll()"
          >
            Apply to All Practices
          </button>
        }
      </div>
    }

    <div class="mt-4">
      @if (selectedPractice(); as activePractice) {
        <pr-referral-email-defaults-practice [practice]="activePractice" />
      }
    </div>
  </pr-content-container>
</div>
